<div class="row" *appRole="['CuentasContable.Ver']">
    <div class="col-lg-2">
        <app-nav-panel-persona [idPersona]="personaDetailDto.id"></app-nav-panel-persona>
    </div>
    <div class="col-lg-10">
        <app-listado-cuentas-contable-persona [personaDetailDto]="personaDetailDto"></app-listado-cuentas-contable-persona>
    </div>
</div>
